import { gql } from "@grandvisionhq/graphql";
import { checkoutMutationResult } from "../../../fragments/operations/fragments/checkout-mutation-result.js";
import { shipmentMethodDoesNotMatchCartFailure, unknownUpdateCartFailure, shipmentMethodNotFoundFailure } from "../../../fragments/operations/fragments/cart-mutation-failures.js";
const SET_SHIPPING_STATE = gql`
  mutation SetShippingState($shippingStateInput: ShippingStateInput!) {
    setShippingState(shippingStateInput: $shippingStateInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...ShipmentMethodNotFoundFailureFragment
        ...ShipmentMethodDoesNotMatchCartFailureFragment
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${shipmentMethodDoesNotMatchCartFailure}
  ${unknownUpdateCartFailure}
  ${shipmentMethodNotFoundFailure}
`;
export {
  SET_SHIPPING_STATE
};
//# sourceMappingURL=set-shipping-state.js.map
